((i) => {
	i('a[href^="#"]').click(function () {
		const speed = 500;
		let href = i(this).attr("href");
		let target = i(href == "#" || href == "" ? "html" : href);
		let header = i('.js-header').outerHeight();
		let position = target.offset().top - header;
		i("body,html").animate({ scrollTop: position }, speed, "swing");
		return false;
	});

	i('.js-header-btn').click(function () {
		i(this).add('.js-header-menu').toggleClass('is-open');
		i('body').toggleClass('is-hidden');
	});

	i('.js-header-btn a').click(function () {
		i(this).add('.js-header-menu').toggleClass('is-open');
		i('body').toggleClass('is-hidden');
	});

	function setHeaderHeight() {
		const headerHeight = $('.js-header').outerHeight();
		$('html').css('--header-h', `${headerHeight}px`);
	}

	i(window).on('load resize', function () {
		setHeaderHeight();
	});

	// 汎用トグル
	if ($('.js-toggle-cnt').length) {
		$('.js-toggle-cnt').hide();
	}
	$('.js-toggle-btn').click(function () {
		const $btn = $(this);
		const $cnt = $btn.next('.js-toggle-cnt');
		const toggleLabel = $btn.data('toggle-label');

		$cnt.slideToggle(300);
		$btn.toggleClass('is-active');

		ScrollTrigger.refresh();
	});
})(jQuery);

//正確なvw数値の取得
const setVw = function () {
	const vw = document.documentElement.clientWidth / 100;
	document.documentElement.style.setProperty("--vw", `${vw}px`);
};
window.addEventListener("DOMContentLoaded", setVw);
window.addEventListener("resize", setVw);